import React, { useState } from 'react';
import { _T, C, CSS } from '../shared/theme';

const TOUR_KEY = 'sl_tour_done';

const SLIDES = [
  {
    icon: '🧘',
    titleNL: 'Welkom bij Sense Lifting',
    titleEN: 'Welcome to Sense Lifting',
    bodyNL: 'Sense Lifting helpt je welzijn te begrijpen en te verbeteren — lichaam én geest. Volg deze rondleiding om alle functies te ontdekken.',
    bodyEN: 'Sense Lifting helps you understand and improve your wellbeing — body and mind. Follow this tour to discover all features.',
    color: '#C8A84B',
  },
  {
    icon: '📊',
    titleNL: 'Dashboard',
    titleEN: 'Dashboard',
    bodyNL: 'Je persoonlijk overzicht. Zie je wekelijkse intentie, slaap & stemming, actieve sessies en de Sense Score — jouw welzijnsindex.',
    bodyEN: 'Your personal overview. See your weekly intention, sleep & mood, active sessions and your Sense Score — your wellness index.',
    color: '#5B9ED0',
    hint: '📍 Tik op het 🦋-logo om terug te gaan naar het dashboard',
    hintEN: '📍 Tap the 🦋 logo to return to dashboard',
  },
  {
    icon: '📅',
    titleNL: 'Week Planner',
    titleEN: 'Week Planner',
    bodyNL: 'Plan je week met bewuste intentie. Voeg taken toe, stel een weekdoel in en visualiseer je mentale en fysieke belasting per dag.',
    bodyEN: 'Plan your week with conscious intention. Add tasks, set a weekly goal and visualise your mental and physical load per day.',
    color: '#2A9E82',
    hint: '📍 Zweef over een dag om de belasting te bekijken',
    hintEN: '📍 Hover a day to inspect the load balance',
  },
  {
    icon: '🏋️',
    titleNL: 'Oefeningen',
    titleEN: 'Exercises',
    bodyNL: 'Korte mentale en fysieke oefeningen die direct energie geven. Kies op basis van hoe je je voelt en verdien XP punten. Jij bouwt hier je Atleet badge.',
    bodyEN: 'Short mental and physical exercises that give instant energy. Choose based on how you feel and earn XP. This is where you build your Athlete badge.',
    color: '#4AC87A',
    hint: '📍 Elke voltooide sessie telt mee voor je badge',
    hintEN: '📍 Every completed session counts toward your badge',
  },
  {
    icon: '🎮',
    titleNL: 'Hersenspellen',
    titleEN: 'Brain Games',
    bodyNL: 'Train je concentratie, reactietijd en geheugen. Speel solo of daag vrienden uit. Bouw je Game Master badge op terwijl je hersens scherp houdt.',
    bodyEN: 'Train your concentration, reaction time and memory. Play solo or challenge friends. Build your Game Master badge while keeping your brain sharp.',
    color: '#7B6FD0',
    hint: '📍 Multiplayer games verstuur je via de vriendenlijst',
    hintEN: '📍 Multiplayer games are sent via the friends list',
  },
  {
    icon: '🦋',
    titleNL: 'Coach',
    titleEN: 'Coach',
    bodyNL: 'Je persoonlijke AI-welzijnscoach. Krijg inzichten, tips en begeleiding op basis van jouw doelen, slaap, stemming en voortgang.',
    bodyEN: 'Your personal AI wellness coach. Get insights, tips and guidance based on your goals, sleep, mood and progress.',
    color: '#C8A84B',
  },
  {
    icon: '🎯',
    titleNL: 'Doelen',
    titleEN: 'Goals',
    bodyNL: 'Stel SMART-doelen in op meerdere levensgebieden: fitness, mentaal, sociaal en meer. Volg je groei week na week.',
    bodyEN: 'Set SMART goals across life areas: fitness, mental, social and more. Track your growth week by week.',
    color: '#C05050',
  },
  {
    icon: '😴',
    titleNL: 'Slaap & Stemming',
    titleEN: 'Sleep & Mood',
    bodyNL: 'Log dagelijks je slaapuren en stemming. De app herkent patronen en waarschuwt vroeg bij tekenen van vermoeidheid of burnout.',
    bodyEN: 'Log your daily sleep hours and mood. The app recognises patterns and warns early at signs of fatigue or burnout.',
    color: '#5B9ED0',
    hint: '📍 Hoe meer data, hoe slimmer de patronen',
    hintEN: '📍 The more data, the smarter the patterns',
  },
  {
    icon: '👥',
    titleNL: 'Community',
    titleEN: 'Community',
    bodyNL: 'Verbind met anderen, deel berichten en oefeningen. Reageer op posts, voeg vrienden toe en speel games samen. Je sociale badges worden hier verdiend.',
    bodyEN: 'Connect with others, share posts and exercises. React to posts, add friends and play games together. Your social badges are earned here.',
    color: '#2A9E82',
  },
  {
    icon: '🏢',
    titleNL: 'Business Dashboard',
    titleEN: 'Business Dashboard',
    bodyNL: 'Als je een Companies-licentie hebt kun je een bedrijfsprofiel aanmaken. Beheer teamwelzijn, programma\'s, pulsemeting en HR — alles op één plek.',
    bodyEN: 'With a Companies license you can create a business profile. Manage team wellness, programs, pulse surveys and HR — all in one place.',
    color: '#C8A84B',
    hint: '📍 Dubbeltik op je profielfoto om snel te wisselen',
    hintEN: '📍 Double-tap your profile photo to switch quickly',
  },
];

export default function FeatureTourModal({ lang, onClose }) {
  const nl = lang === 'nl';
  const [step, setStep] = useState(0);
  const slide = SLIDES[step];
  const isLast = step === SLIDES.length - 1;

  const finish = () => {
    localStorage.setItem(TOUR_KEY, '1');
    onClose();
  };

  const skip = () => {
    localStorage.setItem(TOUR_KEY, '1');
    onClose();
  };

  return (
    <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, zIndex: 9990, background: 'rgba(5,10,20,0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <style>{CSS}</style>
      <div style={{ background: _T.bg2, borderRadius: 24, padding: '28px 24px 24px', width: '100%', maxWidth: 420, border: `1px solid ${slide.color}33`, boxShadow: `0 0 60px ${slide.color}22, 0 24px 64px rgba(0,0,0,0.6)`, position: 'relative' }}>

        {/* Close / skip button */}
        <button onClick={skip} style={{ position: 'absolute', top: 12, right: 12, background: 'transparent', border: 'none', color: C.silver, fontSize: 20, cursor: 'pointer', padding: 4, lineHeight: 1 }}>✕</button>

        {/* Step dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 5, marginBottom: 20 }}>
          {SLIDES.map((_, i) => (
            <div key={i} onClick={() => setStep(i)} style={{ width: i === step ? 18 : 6, height: 6, borderRadius: 3, background: i === step ? slide.color : `${C.silver}40`, cursor: 'pointer', transition: 'all 0.2s' }} />
          ))}
        </div>

        {/* Icon */}
        <div style={{ textAlign: 'center', fontSize: 52, marginBottom: 16, filter: `drop-shadow(0 0 16px ${slide.color}88)` }}>
          {slide.icon}
        </div>

        {/* Title */}
        <div style={{ textAlign: 'center', color: slide.color, fontSize: 18, fontWeight: 800, fontFamily: 'Georgia,serif', marginBottom: 10 }}>
          {nl ? slide.titleNL : slide.titleEN}
        </div>

        {/* Body */}
        <div style={{ textAlign: 'center', color: C.silver2, fontSize: 14, lineHeight: 1.7, marginBottom: 16 }}>
          {nl ? slide.bodyNL : slide.bodyEN}
        </div>

        {/* Hint */}
        {(nl ? slide.hint : slide.hintEN) && (
          <div style={{ background: `${slide.color}12`, border: `1px solid ${slide.color}33`, borderRadius: 12, padding: '9px 14px', marginBottom: 16, fontSize: 11, color: slide.color, textAlign: 'center' }}>
            {nl ? slide.hint : slide.hintEN}
          </div>
        )}

        {/* Navigation */}
        <div style={{ display: 'flex', gap: 8 }}>
          {step > 0 && (
            <button onClick={() => setStep(s => s - 1)} style={{ flex: 1, background: _T.bg4, border: `1px solid ${_T.cardBorderBot}`, borderRadius: 12, color: C.silver, fontSize: 14, fontWeight: 600, padding: '12px', cursor: 'pointer' }}>
              ‹ {nl ? 'Vorige' : 'Back'}
            </button>
          )}
          {isLast ? (
            <button onClick={finish} style={{ flex: 1, background: `linear-gradient(135deg,${_T.grad1},${_T.grad2})`, border: 'none', borderRadius: 12, color: '#0a1220', fontSize: 14, fontWeight: 800, padding: '12px', cursor: 'pointer' }}>
              🚀 {nl ? 'Starten!' : 'Get started!'}
            </button>
          ) : (
            <button onClick={() => setStep(s => s + 1)} style={{ flex: 1, background: `linear-gradient(135deg,${slide.color},${slide.color}cc)`, border: 'none', borderRadius: 12, color: '#0a1220', fontSize: 14, fontWeight: 700, padding: '12px', cursor: 'pointer' }}>
              {nl ? 'Volgende' : 'Next'} ›
            </button>
          )}
        </div>

        {/* Progress text */}
        <div style={{ textAlign: 'center', marginTop: 12, fontSize: 10, color: `${C.silver}60` }}>
          {step + 1} / {SLIDES.length}
        </div>
      </div>
    </div>
  );
}

export { TOUR_KEY };
